import React from "react";

const Tools = ({
  height = "24",
  width = "24",
  viewBox = "0 0 24 24",
  color = "#000"
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={height}
    height={width}
    viewBox={viewBox}
  >
    <g fill="none" fillRule="evenodd" transform="translate(0 0)">
      <rect width="64" height="64" />
      <g fill={color} fillRule="nonzero" transform="translate(0 3)">
        <rect
          width="3"
          height="8.48"
          x="14.241"
          y="10.257"
          transform="rotate(-45 15.741 14.497)"
        />
        <path d="M15.4,7.3875 C17.33,7.3875 18.9,5.8175 18.9,3.8875 C18.9,3.3075 18.74,2.7675 18.49,2.2875 L15.79,4.9875 L14.3,3.4975 L17,0.7975 C16.52,0.5475 15.98,0.3875 15.4,0.3875 C13.47,0.3875 11.9,1.9575 11.9,3.8875 C11.9,4.2975 11.98,4.6875 12.11,5.0475 L10.26,6.8975 L8.48,5.1175 L9.19,4.4075 L7.78,2.9975 L9.9,0.8775 C8.73,-0.2925 6.83,-0.2925 5.66,0.8775 L2.12,4.4175 L3.53,5.8275 L0.71,5.8275 L4.4408921e-16,6.5375 L3.54,10.0775 L4.25,9.3675 L4.25,6.5375 L5.66,7.9475 L6.37,7.2375 L8.15,9.0175 L0.74,16.4275 L2.86,18.5475 L14.24,7.1775 C14.6,7.3075 14.99,7.3875 15.4,7.3875 Z" />
      </g>
    </g>
  </svg>
);

export default Tools;
